'use client'

import { DialogTitle, DialogContent, DialogActions, Divider } from '@mui/material'
import FareSelectionHeader from './fareFamilyHeader/fareFamilyHeader'
import FareSelectionBody from './fareFamilyBody/fareFamilyBody'
import FareModalFooter from './fareFamilyFooter/fareFamilyFooter'
import { useFareFamilyPlanSync, useFareFilterToggle } from '@/src/hooks/srp/fareFamilySRP/useFareFamilyPlanSync'
import { FareModalProps } from './types'
import { useRef } from 'react'


export default function FareFamilyDesktop({
    plans,
    fareFamilySectors,
    handleClose,
    handleFareFamilyBookClick,
    farePlanState,
    setFarePlanState
}: FareModalProps) {
    useFareFamilyPlanSync({
        plans,
        selectedFlightIndex: farePlanState.selectedFlightIndex,
        selectedPlanFareKey: farePlanState.selectedPlanFareKey,
        selectedFilters: farePlanState.selectedFilters,
        setFarePlanState,
        currentFilteredPlans: farePlanState.filteredPlans,
    });

    const handleFilterChange = useFareFilterToggle(setFarePlanState);

    const selectedPlan = plans[farePlanState.selectedFlightIndex]?.find(
        p => p.fareKey === farePlanState.selectedPlanFareKey
    )
    const plansScrollRef = useRef<HTMLDivElement>(null);

    return (
        <>
            <DialogTitle
                sx={{
                    overflow: 'visible',
                    px: { md: '0.7rem', lg: '1.1rem' },
                    pt: { md: '0.7rem', lg: '1.1rem' },
                    pb: 0,
                    position: 'sticky',
                    top: 0,
                    backgroundColor: 'background.paper',
                    zIndex: 1
                }}
            >
                <FareSelectionHeader
                    handleClose={handleClose}
                    selectedFilters={farePlanState.selectedFilters}
                    onFilterChange={handleFilterChange}
                    selectedFlightIndex={farePlanState.selectedFlightIndex}
                    setFarePlanState={setFarePlanState}
                    fareFamilySectors={fareFamilySectors}
                    plansScrollRef={plansScrollRef}
                    plansCount={plans[farePlanState.selectedFlightIndex]?.length || 0}
                />
            </DialogTitle>

            <DialogContent 
                sx={{ 
                    overflow: 'auto',
                    p: { md: '0.5rem', lg: '1.5rem' },
                    '&::-webkit-scrollbar': {
                        display: 'none'
                    },
                    scrollbarWidth: 'none', // Firefox
                    msOverflowStyle: 'none' // IE and Edge
                }}
            >
                <FareSelectionBody
                    setFarePlanState={setFarePlanState}
                    farePlanState={farePlanState}
                    plansScrollRef={plansScrollRef}
                />
            </DialogContent>

            <Divider />

            <DialogActions
                sx={{
                    position: 'sticky',
                    bottom: 0,
                    backgroundColor: 'background.paper',
                    zIndex: 1,
                    borderTop: '1px solid',
                    borderColor: 'divider'
                }}
            >
                {selectedPlan && (
                    <FareModalFooter
                        selectedPlan={selectedPlan}
                        handleFareFamilyBook={() => {
                            handleClose()
                            handleFareFamilyBookClick(selectedPlan)
                        }}
                        exclusiveBenefits={selectedPlan.benefitsText.exclusiveBenefits}
                    />
                )}
            </DialogActions>
        </>
    )
}